// @ts-expect-error
import UIEvents from '../../../service/UI/UIEvents';
import { VIDEO_MUTE, createToolbarEvent } from '../analytics/AnalyticsEvents';
import { sendAnalytics } from '../analytics/functions';
import { setAudioOnly } from '../base/audio-only/actions';
import { setVideoMuted } from '../base/media/actions';
import { VIDEO_MUTISM_AUTHORITY } from '../base/media/constants';
// import { getLocalVideoType } from '../base/tracks';
import { CLEAR_TOOLBOX_TIMEOUT, CLEAR_VIDEO_UN_MUTE_TIMEOUT, SET_OVERFLOW_MENU_VISIBLE, SET_TOOLBAR_HOVERED, SET_TOOLBOX_ALWAYS_VISIBLE, SET_TOOLBOX_ENABLED, SET_TOOLBOX_VISIBLE, TOGGLE_TOOLBOX_VISIBLE, SET_VIDEO_UN_MUTE_TIME_OUT_MS, SET_VIDEO_UN_MUTE_TIMEOUT, SET_NOTIFY_VISIBLE } from './actionTypes';
/**
 * Signals that toolbox timeout should be cleared.
 *
 * @returns {{
*     type: CLEAR_TOOLBOX_TIMEOUT
* }}
*/
export function clearToolboxTimeout() {
    return {
        type: CLEAR_TOOLBOX_TIMEOUT
    };
}
/**
 * Shows/hides the overflow menu.
 *
 * @param {boolean} visible - True to show it or false to hide it.
 * @returns {{
*     type: SET_OVERFLOW_MENU_VISIBLE,
*     visible: boolean
* }}
*/
export function setOverflowMenuVisible(visible) {
    return {
        type: SET_OVERFLOW_MENU_VISIBLE,
        visible
    };
}
/**
 * Signals that toolbar is hovered value should be changed.
 *
 * @param {boolean} hovered - Flag showing whether toolbar is hovered.
 * @returns {{
*     type: SET_TOOLBAR_HOVERED,
*     hovered: boolean
* }}
*/
export function setToolbarHovered(hovered) {
    return {
        type: SET_TOOLBAR_HOVERED,
        hovered
    };
}
/**
 * Enables/disables the toolbox.
 *
 * @param {boolean} enabled - True to enable the toolbox or false to disable it.
 * @returns {{
 *     type: SET_TOOLBOX_ENABLED,
 *     enabled: boolean
 * }}
 */
export function setToolboxEnabled(enabled) {
    return {
        type: SET_TOOLBOX_ENABLED,
        enabled
    };
}
/**
 * Signals that always visible toolbars value should be changed.
 *
 * @param {boolean} alwaysVisible - Value to be set in redux store.
 * @returns {{
*     type: SET_TOOLBOX_ALWAYS_VISIBLE,
*     alwaysVisible: boolean
* }}
*/
export function setToolboxAlwaysVisible(alwaysVisible) {
    return {
        type: SET_TOOLBOX_ALWAYS_VISIBLE,
        alwaysVisible
    };
}
/**
 * Shows/hides the toolbox.
 *
 * @param {boolean} visible - True to show the toolbox or false to hide it.
 * @returns {Function}
 */
export function setToolboxVisible(visible) {
    return (dispatch, getState) => {
        const { toolbarConfig } = getState()['features/base/config'];
        const alwaysVisible = toolbarConfig === null || toolbarConfig === void 0 ? void 0 : toolbarConfig.alwaysVisible;
        if (!visible && alwaysVisible) {
            return;
        }
        dispatch({
            type: SET_TOOLBOX_VISIBLE,
            visible
        });
    };
}
export function setVolumeVisible() {
    return {
        type: SET_NOTIFY_VISIBLE
    };
}
/**
 * Action to toggle the toolbox visibility.
 *
 * @returns {Function}
 */
export function toggleToolboxVisible() {
    return (dispatch, getState) => {
        const state = getState();
        const { toolbarConfig } = getState()['features/base/config'];
        const alwaysVisible = toolbarConfig === null || toolbarConfig === void 0 ? void 0 : toolbarConfig.alwaysVisible;
        const { visible } = state['features/toolbox'];
        if (visible && alwaysVisible) {
            return;
        }
        dispatch({
            type: TOGGLE_TOOLBOX_VISIBLE
        });
    };
}
export const clearVideoUnMuteTimeOut = () => {
    return {
        type: CLEAR_VIDEO_UN_MUTE_TIMEOUT
    };
};
export const setVideoUnMuteTimeOutMs = (timeoutMs) => {
    return {
        type: SET_VIDEO_UN_MUTE_TIME_OUT_MS,
        timeoutUnMuteMs: timeoutMs
    };
};
export const setVideoUnMuteTimeOut = (handler, timeoutMs) => {
    return {
        type: SET_VIDEO_UN_MUTE_TIMEOUT,
        handler,
        timeoutMs
    };
};
export const callingFamily = (status) => {
    return {
        type: 'HANDLE_CALLING_FAMILY',
        status
    };
};
export const _setVideoMuted = (videoMuted = false) => () => {
    handleToggleVideoMuted(videoMuted, true, false);
};
/**
 * Action to handle toggle video from toolbox's video buttons.
 *
 * @param {boolean} muted - Whether to mute or unmute.
 * @param {boolean} showUI - When set to false will not display any error.
 * @param {boolean} ensureTrack - True if we want to ensure that a new track is
 * created if missing.
 * @returns {Function}
 */
export function handleToggleVideoMuted(muted, showUI, ensureTrack) {
    return (dispatch, getState) => {
        const state = getState();
        const { enabled: audioOnly } = state['features/base/audio-only'];
        sendAnalytics(createToolbarEvent(VIDEO_MUTE, { enable: muted }));
        if (audioOnly) {
            dispatch(setAudioOnly(false));
        }
        dispatch(setVideoMuted(muted, VIDEO_MUTISM_AUTHORITY.USER, ensureTrack));
        // FIXME: The old conference logic still relies on this event being
        // emitted.
        typeof APP === 'undefined'
            || APP.UI.emitEvent(UIEvents.VIDEO_MUTED, muted, showUI);
    };
}
